module.exports = __webpack_public_path__ + "static/media/rmt-front.35e16d3b.jpg";